import styled from 'styled-components';

type ColorsScheme = {
  color: {
    background: string;
  };
};

export type Appearance = 'info' | 'warning';

const Colors: Record<Appearance, ColorsScheme> = {
  info: {
    color: {
      background:
        'var(--ds-background-information, var(--ds-fb-background-information))',
    },
  },
  warning: {
    color: {
      background:
        'var(--ds-background-warning, var(--ds-fb-background-warning));',
    },
  },
};

export type ContainerProps = { appearance: Appearance };

export const ContainerStyled = styled.div<ContainerProps>`
  box-sizing: border-box;

  width: 100%;
  min-height: 56px;
  padding: 16px;
  margin: 0 0 8px;

  background: ${({ appearance }) => Colors[appearance].color.background};

  display: flex;
`;

export const ContentWrapperStyled = styled.div`
  flex: 1 1 auto;

  display: flex;
  place-items: center;
  place-content: center;

  white-space: pre-wrap;
`;

export const SlotStyled = styled.div`
  flex: 0 0 auto;
`;
